import navigationService from '@/utils/navigation-service';

/**
 * Mixin to register custom back navigation handler
 * Use this in pages that have custom back button logic
 * Swipe gestures will automatically use the registered back() method
 */
export default {
  mounted() {
    // Register the back handler when page is mounted
    if (this.back && typeof this.back === 'function') {
      navigationService.registerBackHandler(this.back.bind(this), this.$route.path);
    }
  },

  beforeUnmount() {
    // Clear the handler when page is about to unmount
    navigationService.clearBackHandler();
  },

  // For Vue 2 compatibility (if needed)
  beforeDestroy() {
    navigationService.clearBackHandler();
  },
};
